module.exports = __webpack_public_path__ + "43cbe1145b837997b4bc00e5064859f6.png";